<ng-container *transloco="let t">

    <!-- Standort-Karte: wird von Carousel (mobil) und Liste (Desktop) gemeinsam verwendet -->
    <ng-template #locationCard let-location="location">
        <div class="flex flex-col md:flex-row bg-card shadow overflow-hidden cursor-pointer"
             [ngClass]="{'bg-hover': highlightListItem?.id === location?._id}"
             (click)="naviagteToLocation(location)" (mouseover)="panMap(location)">

            <!-- Foto: mobil als Header (feste Höhe), am Desktop als linke Spalte —
                 sonst wird das Bild bei voller Breite zum schmalen Streifen.
                 Ohne Foto: Logo-Platzhalter mit demselben Abdunklungs-Filter -->
            <div class="relative w-full h-40 md:h-auto md:w-2/5 md:min-h-56 flex-none">
                <img class="absolute inset-0 w-full h-full object-cover"
                     *ngIf="location?.imagePath && !location.imageFailed"
                     [src]="'/api/public-files/image/' + location?.imagePath"
                     (error)="location.imageFailed = true"
                     [alt]="location?.name">
                <div class="absolute inset-0 flex items-center justify-center bg-gray-800"
                     *ngIf="!location?.imagePath || location.imageFailed">
                    <img class="w-56 max-w-full px-8" src="/assets/images/logo/lagerage_orange_logo.svg" alt="Lagerage">
                </div>
                <div class="absolute inset-0" style="box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 45%);"></div>
                <div class="absolute bottom-3 left-4 right-4 flex flex-row items-end justify-between gap-2">
                    <div class="font-bold text-xl text-white min-w-0 truncate">{{location?.name}}</div>
                    <div class="bg-gray-700 text-white text-sm px-2 py-0.5 whitespace-nowrap"
                         *ngIf="userLocation && location?.distanceToUser">{{location?.distanceToUser}} km
                    </div>
                </div>
            </div>

            <div class="flex flex-col justify-center px-4 py-3 md:flex-1 min-w-0">
                <!-- Kernfakten: freie Abteile & Öffnungszeiten, je eine Zeile -->
                <div class="flex flex-row items-center">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:template'"></mat-icon>
                    <div class="ml-2 text-md" *ngIf="location?.freeUnits?.length > 0; else noFreeUnits">
                        {{t('text-free-units')}}: <span class="text-green-600 font-bold">{{location?.freeUnits?.length}}</span>
                    </div>
                    <ng-template #noFreeUnits>
                        <div class="ml-2 text-md text-red-600 font-bold">{{t('booking-no-free-units-title')}}</div>
                    </ng-template>
                </div>
                <div class="flex flex-row items-center mt-1.5 text-secondary">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                    <div class="ml-2 text-md">{{t('text-business-hours')}}: {{formatOpeningHours(location)}}</div>
                </div>

                <!-- Adresse & Leistungen -->
                <div class="flex flex-col gap-1.5 mt-1.5 mb-1">
                    <div class="flex flex-row items-start">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:home'"></mat-icon>
                        <div class="ml-2 text-md">
                            {{location?.address?.street }} {{location?.address?.houseNumber}},
                            {{location?.address?.postalCode}} {{location?.address?.city}}
                        </div>
                    </div>
                    <div class="flex flex-row items-center">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:cog'"></mat-icon>
                        <div class="ml-2 text-md underline"
                             (click)="showServicesDialog($event, location)">{{t('text-services')}}: {{t('button-show-all')}}</div>
                    </div>
                </div>

                <!-- CTA volle Breite; Info-Block inkl. Button ist vertikal zum Bild zentriert -->
                <button mat-flat-button (click)="naviagteToLocation(location)"
                        class="bg-primary text-black w-full mt-4">{{t('quick-book-button')}}
                </button>
            </div>
        </div>
    </ng-template>

    <!-- Mobil: Karten zum Wischen mit Punkten, wie das Bilder-Carousel auf der Landingpage.
         min-w-0/overflow-hidden: sonst bläht die Owl-Stage (Slides nebeneinander) die Flex-Eltern auf -->
    <div class="flex flex-col w-full min-w-0 max-w-full overflow-hidden" *ngIf="mobile">
        <owl-carousel-o [options]="carouselOptions">
            <ng-template carouselSlide *ngFor="let location of locations" [id]="location?._id">
                <div class="p-2">
                    <ng-container *ngTemplateOutlet="locationCard; context: {location: location}"></ng-container>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>

    <!-- Desktop: scrollbare Liste neben der Karte -->
    <div class="flex flex-col w-full" *ngIf="!mobile">
        <ng-container cdkScrollable>
            <cdk-virtual-scroll-viewport [itemSize]="300" class="example-viewport">
                <div class="flex flex-col p-2"
                     *ngFor="let location of locations; let i = index;">
                    <ng-container *ngTemplateOutlet="locationCard; context: {location: location}"></ng-container>
                </div>
            </cdk-virtual-scroll-viewport>
        </ng-container>
    </div>
</ng-container>
